"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ohhhData_1 = require("./assets/ohhhData");
var ohhhEgg = {
    name: "ohhh",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["o", "h", "h", "h"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/GWAyANH.png";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "400px";
        img.style.height = "300px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 200px)";
        img.style.bottom = "-300px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "0px";
        }, 0);
        window.setTimeout(function () {
            img.style.bottom = "-300px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            shock.parentNode.removeChild(shock);
        }, 5400);
        // Play sound;
        var sound = new Audio("data:audio/mp3;base64," + ohhhData_1.audioInit);
        sound.play();
    },
};
exports.default = ohhhEgg;
